// This is the DOM element that is assumed to exist
// where the SearchMask component will be mounted.
export const getTarget = () => document.getElementById('search-mask-component');

// SearchMask is considered to be isolated when the target element contains this attribute
export const isIsolated =
  getTarget() !== null && getTarget()?.getAttribute('data-isolated') !== null;
